import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IonCol, IonRow, IonButton } from '@ionic/react';

import { setLoadPileType } from 'actions/ProjectDataActions';
import { userSettingsSelector } from 'selectors/userSelector';
import { readOnlySelector } from 'selectors/projectSelector';

import { ProjectContext } from 'components/layouts/Project';
import PileGraph from 'components/project/pile-visualizer/PileGraph';
import PileOptions from './PileOptions';
import PushPierOptions from './PushPierOptions';

export default function Pile({load}) {
  const dispatch = useDispatch();
  const {settings, data} = useContext(ProjectContext);
  const readonly = useSelector(readOnlySelector);
  const userDefaultPileType = useSelector(userSettingsSelector.at('defaultPileType'));
  const defaultPileType = load.tension ? "helical" : userDefaultPileType;
  const pushPier = (load.pileType ?? defaultPileType) == "push_pier";

  const switchPileType = () => {
    if (load.tension) {
      alert('Push Piers do not support tension loads.')
      return;
    }
    if (!load.pileType || window.confirm("Changing pile types will reset your selections. Continue?")) {
      dispatch(setLoadPileType(load.id, pushPier ? 'helical' : 'push_pier'));
    }
  };

  return (
    <IonRow className="narrow-container no-wrap">
      <IonCol size={3}>
        <PileGraph load={load}
          {..._.pick(data, 'blowCounts', 'boundaries', 'soilTypes')}
          {..._.pick(settings, 'interval', 'lengthUnit')}/>
      </IonCol>
      <IonCol>
        {!readonly && (
          <IonButton onClick={switchPileType} size="small" color="secondary" className="pile-type-button">
            Switch to {pushPier ? "Helical Pile" : "Push Pier"}
          </IonButton>
        )}
        {pushPier ? (
          <PushPierOptions load={load} readonly={readonly}/>
        ) : (
          <PileOptions load={load} data={data} settings={settings} readonly={readonly}/>
        )}
      </IonCol>
    </IonRow>
  );
}
